export default __webpack_public_path__ + "pdf/eSignDisclosureandConsent-VW.pdf";